import {
  DEFAULT_WIDGET_LAYOUT_SETTINGS,
  OverrideIndicators,
  overrideIndicatorsDefaults,
  WidgetLayoutSettings,
} from '@neptune/shared/widgets-domain';

import { getLayoutSettingsComparison } from './layout-utils';

type Props = {
  sectionLayoutSettings?: WidgetLayoutSettings;
  globalLayoutSettings: WidgetLayoutSettings;
};

export const getSectionLayoutsOverrideIndicators = ({
  sectionLayoutSettings,
  globalLayoutSettings,
}: Props): OverrideIndicators => {
  if (!sectionLayoutSettings) {
    return overrideIndicatorsDefaults;
  }

  const defaultSettingsComparison = getLayoutSettingsComparison(
    sectionLayoutSettings,
    DEFAULT_WIDGET_LAYOUT_SETTINGS,
  );
  const globalSettingsComparison = getLayoutSettingsComparison(
    globalLayoutSettings,
    DEFAULT_WIDGET_LAYOUT_SETTINGS,
  );

  if (!globalSettingsComparison.hasConflict) {
    return {
      ...overrideIndicatorsDefaults,
      showMainIndicator: defaultSettingsComparison.hasConflict,
      showModeConflictIndicator: defaultSettingsComparison.hasModeConflict,
      showColumnCountsConflictIndicator: defaultSettingsComparison.hasColumnCountsConflict,
    };
  }

  const sectionAgainstGlobalComparison = getLayoutSettingsComparison(
    sectionLayoutSettings,
    globalLayoutSettings,
  );

  return {
    ...overrideIndicatorsDefaults,
    showMainIndicator:
      defaultSettingsComparison.hasConflict || sectionAgainstGlobalComparison.hasConflict,
    mainIndicatorColor: sectionAgainstGlobalComparison.hasConflict ? 'warning' : 'info',
    showSectionOverrideBadge: sectionAgainstGlobalComparison.hasConflict,
    showModeConflictIndicator: sectionAgainstGlobalComparison.hasModeConflict,
    showColumnCountsConflictIndicator: sectionAgainstGlobalComparison.hasColumnCountsConflict,
  };
};
